import type { CommunityGroup } from '@communities/community-groups/domain';
import { Card, Heading, Text } from '@soteria/design-system-ve';

import * as styles from './CommunityGroupCard.css.ts';

interface CommunityGroupCardProps {
  communityGroup: CommunityGroup;
  isSelected: boolean;
  onClick: (communityGroup: CommunityGroup) => void;
  isAdmin?: boolean;
  communitiesCount?: number;
}

/**
 * Card component for displaying a community group with action, classification, and moderation counts
 */
export function CommunityGroupCard({
  communityGroup,
  isSelected,
  onClick,
  isAdmin: _isAdmin = false,
  communitiesCount: _communitiesCount = 0,
}: CommunityGroupCardProps) {
  // Calculate counts

  return (
    <Card
      className={styles.cardContainer}
      elevation={isSelected ? 'high' : 'medium'}
      isSelected={isSelected}
      padding="medium"
      width="full"
      onSelect={() => onClick(communityGroup)}
    >
      <Heading level="h2" size="xl" weight={isSelected ? 'bold' : 'semibold'}>
        {communityGroup.name}
      </Heading>

      <Text className={styles.description} color="secondary" size="sm">
        {communityGroup.description || 'No description available'}
      </Text>
    </Card>
  );
}
